import React, {Component} from 'react';
import {Row, Col, Alert, Timeline, Card} from 'antd';
import ReactJson from 'react-json-view';

import {Order} from '../../../../../../interfaces';

const {Item} = Timeline;

interface Properties {
  orderData: Order;
}

class Detail extends Component<Properties> {
  render() {
    const {orderData} = this.props;
    return (
      <>
        {orderData.order.orderRessurectionLink && (
          <Row>
            <Col span={24}>
              <Card title="Order ressurection link" bordered={false}>
                <a target="_blank" href={orderData.order.orderRessurectionLink}>
                  {orderData.order.orderRessurectionLink}
                </a>
              </Card>
            </Col>
          </Row>
        )}
        <Row>
          <Col span={8}>
            <Card title="Order data" bordered={false}>
              <ReactJson name={false} src={orderData.order} collapsed={1} />
            </Card>
          </Col>
          <Col span={8}>
            <Card title="Payment data" bordered={false}>
              <ReactJson name={false} src={orderData.payment} collapsed={1} />
            </Card>
          </Col>
          <Col span={8}>
            <Card title="Order status history" bordered={false}>
              <Timeline>
                {orderData.order.history.map((item: any, i: number) => {
                  const getColor = (type: any, err: any) => {
                    switch (type) {
                      case 'info':
                        return 'green';
                      case 'pending':
                        return 'orange';
                      case 'error':
                        return 'red';
                      default:
                        if (err && !type) {
                          return 'red';
                        }

                        return 'green';
                    }
                  };

                  return (
                    <Item color={getColor(item.type, item.err)} key={i}>
                      <span>{item.message}</span>
                      {item.err && (
                        <span>
                          <Alert message={<ReactJson name={false} src={item.err} collapsed />} type={item.type || 'error'} showIcon />
                        </span>
                      )}
                    </Item>
                  );
                })}
              </Timeline>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/components/Detail/Detail.tsx